import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import HistoryRowControls from 'Components/HistoryRowControls';
import HistorySection from 'Components/HistorySection';
import PlatformConditional from 'Components/PlatformConditional';
import HistoryRowListing from 'Components/HistoryRowListing';
import { Item } from 'Components/Grid';

import DocumentCreationButton from 'Components/DocumentCreationButton';
import { formatPartialDate } from 'Utility/date';
import { statementStyle } from '../Components/Statement';

const NerveUltrasound = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  const showProcedureCodeHeader = documents.some(d => d.procedureCode && d.procedureCode.length > 0);
  const showStatementHeader = documents.some(d => d.statement && d.statement.length > 0);

  const showProcedureCode = (d: IMRI) => d.procedureCode && d.procedureCode.length > 0;
  const showStatement = (d: IMRI) => d.statement && d.statement.length > 0;

  return (
    <React.Fragment>
      <PlatformConditional platform={'polyneuro'}>
        <HistorySection
          headerText={<FormattedMessage id={'imaging.nerveUltrasound'} />}
          newButton={
            <DocumentCreationButton
              name="nerveUltrasound"
              text={'imaging.newNerveUltrasound'}
              onClick={startEdit({}, 'nerveUltrasound')}
              width={15}
              height={3}
              fontSize={14}
              alternate={true}
            />
          }
        >
          <HistoryRowListing
            documents={documents}
            headers={
              <React.Fragment>
                <Item xs={2}>
                  <FormattedMessage id={'general.date'} />
                </Item>

                <Item xs={3}>
                  <FormattedMessage id={'imaging.polyneuro.interpretation'} />
                </Item>

                {showProcedureCodeHeader && (
                  <Item xs={2}>
                    <FormattedMessage id={'imaging.procedureCode'} />
                  </Item>
                )}
                {showStatementHeader && (
                  <Item xs={2}>
                    <FormattedMessage id={'imaging.statement'} />
                  </Item>
                )}
                <Item xs={3} />
              </React.Fragment>
            }
            contentFormat={d => (
              <React.Fragment>
                <Item xs={2} id={'mriDate'}>
                  {formatPartialDate(d.date)}
                </Item>

                <Item xs={3} id={'interpretation'}>
                  {d.interpretation && <FormattedMessage id={'imaging.polyneuro.opts.' + d.interpretation} />}
                </Item>

                <Item xs={2}>{showProcedureCode(d) ? d.procedureCode : ''}</Item>
                <Item xs={2} style={statementStyle}>
                  {showStatement(d) ? d.statement : ''}
                </Item>
                <Item xs={3}>
                  <HistoryRowControls document={d} startEdit={startEdit} />
                </Item>
              </React.Fragment>
            )}
          />
        </HistorySection>
      </PlatformConditional>
    </React.Fragment>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'nerveUltrasound'>[];
  startEdit: StartEdit;
}

export default NerveUltrasound;
